import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function ConsultantPage() {
  useEffect(() => {
    const schema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": `${import.meta.env.VITE_SITE_URL}/devenir-consultant`,
          "url": `${import.meta.env.VITE_SITE_URL}/devenir-consultant`,
          "name": "Devenir Consultant Indépendant Belgique - Revenus Complémentaires | JLD Concept",
          "description": "Devenez business consultant indépendant avec JLD Concept et Smart Services Network. Liberté, accompagnement professionnel et revenus complémentaires. Plus de 2000 consultants actifs en Belgique.",
          "inLanguage": "fr-BE",
          "isPartOf": { "@id": `${import.meta.env.VITE_SITE_URL}/#website` }
        },
        {
          "@type": "JobPosting",
          "title": "Business Consultant Indépendant",
          "description": "Rejoignez Smart Services Network en tant que consultant indépendant. Vendez des services télécom Orange Belgique et énergie verte Eneco. Formation complète, kit de démarrage, accompagnement professionnel inclus.",
          "hiringOrganization": {
            "@type": "Organization",
            "name": "JLD Concept SRL",
            "sameAs": import.meta.env.VITE_SITE_URL
          },
          "jobLocation": {
            "@type": "Place",
            "address": {
              "@type": "PostalAddress",
              "addressCountry": "BE",
              "addressLocality": "Belgique"
            }
          },
          "employmentType": "CONTRACTOR",
          "workHours": "Flexible",
          "datePosted": "2025-01-15",
          "validThrough": "2025-12-31"
        }
      ]
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-consultant';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
    return () => { document.getElementById('schema-consultant')?.remove(); };
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />

      <div className="pt-24">
        {/* Hero Section */}
        <section className="relative min-h-[600px] flex items-center justify-center overflow-hidden">
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: 'url(https://public.readdy.ai/ai/img_res/8e99c1a1849af4a5f3c953f8e433fdb3.jpg)',
            }}
          >
            <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/60"></div>
          </div>

          <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
            <h1 className="text-5xl md:text-7xl font-extrabold text-white mb-6 tracking-wide">
              DEVENEZ BUSINESS CONSULTANT
            </h1>
            <p className="text-xl md:text-2xl text-white/90 mb-10 font-light max-w-3xl mx-auto">
              Construisez votre avenir avec liberté, amusement et accompagnement professionnel
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center space-x-4 bg-orange-600 hover:bg-orange-700 text-white px-8 py-4 rounded-full transition-all text-lg whitespace-nowrap"
            >
              <i className="ri-briefcase-line text-2xl"></i>
              <span className="font-semibold">COMMENCER MAINTENANT</span>
              <i className="ri-arrow-right-line text-xl"></i>
            </Link>
          </div>
        </section>

        {/* What You Receive */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
              <div className="inline-block text-sm font-semibold text-orange-600 bg-orange-100 px-4 py-2 rounded-full mb-4">
                VOTRE PACKAGE DE DÉMARRAGE
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                Que recevez-vous?
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Tout ce dont vous avez besoin pour réussir dès le premier jour
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="bg-gradient-to-br from-orange-50 to-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
                <div className="w-16 h-16 flex items-center justify-center bg-orange-100 rounded-xl mb-6">
                  <i className="ri-user-star-line text-3xl text-orange-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  Accompagnement Professionnel
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  Formation complète et suivi personnalisé par des experts pour garantir votre succès
                </p>
              </div>

              <div className="bg-gradient-to-br from-green-50 to-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
                <div className="w-16 h-16 flex items-center justify-center bg-green-100 rounded-xl mb-6">
                  <i className="ri-briefcase-line text-3xl text-green-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  Kit de Démarrage Complet
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  Contrats, cartes SIM et tous les outils de vente nécessaires pour commencer immédiatement
                </p>
              </div>

              <div className="bg-gradient-to-br from-blue-50 to-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
                <div className="w-16 h-16 flex items-center justify-center bg-blue-100 rounded-xl mb-6">
                  <i className="ri-dashboard-line text-3xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  Accès CRM Professionnel
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  Outil de gestion clients, contrats, rémunération et rapports en développement
                </p>
              </div>

              <div className="bg-gradient-to-br from-purple-50 to-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
                <div className="w-16 h-16 flex items-center justify-center bg-purple-100 rounded-xl mb-6">
                  <i className="ri-graduation-cap-line text-3xl text-purple-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  Plateforme Cercom
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  Certification professionnelle et formations instructives pour développer vos compétences
                </p>
              </div>

              <div className="bg-gradient-to-br from-pink-50 to-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
                <div className="w-16 h-16 flex items-center justify-center bg-pink-100 rounded-xl mb-6">
                  <i className="ri-book-open-line text-3xl text-pink-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  MySmart + E-Learning
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  Accès illimité à toutes les ressources de formation en ligne et documentation
                </p>
              </div>

              <div className="bg-gradient-to-br from-teal-50 to-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
                <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-xl mb-6">
                  <i className="ri-customer-service-2-line text-3xl text-teal-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  Soutien Back-Office
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  Équipe administrative dédiée pour vous assister dans toutes vos démarches
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-bold mb-6">
                Pourquoi devenir consultant?
              </h2>
              <p className="text-xl text-gray-300 max-w-3xl mx-auto">
                Plus de 2000 consultants ont déjà rejoint Smart SN et développent leur activité avec succès
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 hover:bg-white/15 transition-all">
                <div className="w-16 h-16 flex items-center justify-center bg-orange-500/20 rounded-xl mb-6">
                  <i className="ri-time-line text-4xl text-orange-400"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">🔸 Liberté</h3>
                <p className="text-gray-300 leading-relaxed">
                  Déterminez vous-même votre agenda. Travaillez quand vous voulez, où vous voulez. 
                  Plus de temps pour ce qui compte vraiment.
                </p>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 hover:bg-white/15 transition-all">
                <div className="w-16 h-16 flex items-center justify-center bg-green-500/20 rounded-xl mb-6">
                  <i className="ri-emotion-happy-line text-4xl text-green-400"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">🔸 Fun</h3>
                <p className="text-gray-300 leading-relaxed">
                  Travaillez avec votre famille et vos amis. Combinez l'utile à l'agréable et 
                  transformez le travail en plaisir.
                </p>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 hover:bg-white/15 transition-all">
                <div className="w-16 h-16 flex items-center justify-center bg-blue-500/20 rounded-xl mb-6">
                  <i className="ri-hand-heart-line text-4xl text-blue-400"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">🔸 Accompagnement</h3>
                <p className="text-gray-300 leading-relaxed">
                  Formation complète et de qualité. Accès permanent aux dernières informations et 
                  support continu.
                </p>
              </div>
            </div>

            <div className="bg-gradient-to-r from-orange-600 to-orange-500 rounded-2xl p-12 text-center">
              <h3 className="text-3xl font-bold mb-6">Commencez sans prendre de risque</h3>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto mb-8">
                <div className="text-center">
                  <i className="ri-store-2-line text-5xl mb-3"></i>
                  <p className="font-medium">Pas de stock de produits</p>
                </div>
                <div className="text-center">
                  <i className="ri-team-line text-5xl mb-3"></i>
                  <p className="font-medium">Pas d'employés</p>
                </div>
                <div className="text-center">
                  <i className="ri-file-list-line text-5xl mb-3"></i>
                  <p className="font-medium">Pas de lourdeur administrative</p>
                </div>
                <div className="text-center">
                  <i className="ri-rocket-line text-5xl mb-3"></i>
                  <p className="font-medium">Démarrage immédiat</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Success Stories */}
        <section className="py-20 bg-gradient-to-br from-orange-50 to-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                Ils ont réussi avec nous
              </h2>
              <p className="text-xl text-gray-600">
                Découvrez les témoignages de nos consultants
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-white rounded-2xl p-8 shadow-lg">
                <div className="flex items-center space-x-4 mb-6">
                  <div
                    className="w-16 h-16 bg-cover bg-center rounded-full"
                    style={{
                      backgroundImage: 'url(https://static.readdy.ai/image/9c58d8b9dc921ceebc49b67abc2b926b/cf9d92deac56ae2fa88ded04ef5a9453.png)',
                    }}
                  ></div>
                  <div>
                    <h4 className="font-bold text-gray-900">Charles Timmermans</h4>
                    <p className="text-sm text-gray-600">National Manager Consultant</p>
                  </div>
                </div>
                <div className="text-orange-500 text-4xl mb-4">"</div>
                <p className="text-gray-600 leading-relaxed">
                  J'étais au chômage avant de rejoindre Smart SN. Aujourd'hui, après 10 ans, 
                  j'ai développé un réseau de plus de 13.000 clients et je manage une équipe 
                  de plus de 100 collaborateurs indépendants. Ma vie a complètement changé!
                </p>
              </div>

              <div className="bg-white rounded-2xl p-8 shadow-lg">
                <div className="flex items-start space-x-4 mb-6">
                  <div
                    className="w-16 h-16 bg-cover bg-center rounded-full flex-shrink-0"
                    style={{
                      backgroundImage: 'url(https://static.readdy.ai/image/9c58d8b9dc921ceebc49b67abc2b926b/8b81e9785e83a7026b9f24295b200523.jpeg)',
                    }}
                  ></div>
                  <div>
                    <h4 className="font-bold text-gray-900 text-lg">Fabian Gulpen</h4>
                    <p className="text-sm text-gray-600">Principal Consultant</p>
                    <div className="flex items-center space-x-1 mt-1">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                      ))}
                    </div>
                  </div>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  "J'ai commencé en plein COVID en 2020 et j'ai quand même réussi. J'ai aujourd'hui plus de 1.400 clients et une belle équipe de consultants. Auparavant, je travaillais dans une entreprise qui fabriquait des moteurs de bateau. Ce que j'aime le plus, c'est aider les gens à économiser de l'argent."
                </p>
              </div>

              <div className="bg-white rounded-2xl p-8 shadow-lg">
                <div className="flex items-center space-x-4 mb-6">
                  <div
                    className="w-16 h-16 bg-cover bg-center rounded-full"
                    style={{
                      backgroundImage: 'url(https://static.readdy.ai/image/9c58d8b9dc921ceebc49b67abc2b926b/d05f4fe091845a61c4c3cebd18fa264e.jpeg)',
                    }}
                  ></div>
                  <div>
                    <h4 className="font-bold text-gray-900">Rosa Scire</h4>
                    <p className="text-sm text-gray-600">Senior Consultant depuis quelques mois</p>
                  </div>
                </div>
                <div className="text-orange-500 text-4xl mb-4">"</div>
                <p className="text-gray-600 leading-relaxed">
                  J'ai commencé il y a quelques mois et j'ai déjà atteint ma première position de 
                  Senior Consultant chez Smart! J'ai plus ou moins 200 clients et une petite équipe 
                  de 7 personnes. Avant j'étais marchande de légumes sur les marchés et je suis 
                  heureuse d'avoir rencontré Jean-Luc Danko, mon Leader Smart SN.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-r from-orange-600 to-orange-500 text-white">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Prêt à commencer votre aventure?
            </h2>
            <p className="text-xl mb-10 opacity-90">
              Rejoignez les 2000+ consultants qui ont déjà fait le choix de la liberté avec Smart SN
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center space-x-3 bg-white text-orange-600 px-8 py-4 rounded-full hover:bg-gray-100 transition-colors text-lg font-semibold whitespace-nowrap"
            >
              <span>Contactez-nous maintenant</span>
              <i className="ri-arrow-right-line text-xl"></i>
            </Link>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
}